import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Notification from '../notification/notification'
import Icon from '../../core/patterns/icon/icon'

import i18n from '../../core/services/i18n/i18n'

import heart from '../../resources/svgs/Heart.svg'
import next from '../../resources/svgs/Arrow.svg'
import styles from './favourite-notification.css'

export default class FavouriteNotification extends PureComponent {
  static propTypes = {
    shown: PropTypes.bool,
    onEnded: PropTypes.func,
    festivalMap: PropTypes.bool,
  }

  render() {
    const { shown, onEnded, festivalMap } = this.props

    return (
      <Notification
        onAnimationEnded={onEnded}
        shown={shown}
        festivalMap={festivalMap}
      >
        <section>
          <Icon glyph={heart} className={styles['icon']} />
          <strong className={styles['text']}>
            {i18n.get('Notification.FavouriteMessage')}
          </strong>
          <a className={styles['link']} href="/account/favourites">
            {i18n.get('Notification.ManageFavourite')}{' '}
            <Icon glyph={next} className={styles['next']} />
          </a>
        </section>
      </Notification>
    )
  }
}
